import { resolveLink } from '../lib/parse';

/** <a> that understands sheet-style links: full URLs, mailto:, old "Bio" paths, #anchors. */
export default function SmartLink({ url, children, className, ...rest }) {
  const { href, external } = resolveLink(url);
  if (!href) return <span className={className}>{children}</span>;
  return (
    <a className={className} href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} {...rest}>
      {children}
    </a>
  );
}
